var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5915 11.0081L8.0002 5.41683L2.40888 11.0081C2.018 11.399 1.38425 11.399 0.99336 11.0081C0.602474 10.6173 0.602474 9.98351 0.99336 9.59262L7.29309 3.29289C7.68361 2.90237 8.31678 2.90237 8.7073 3.29289L15.007 9.59262C15.3979 9.98351 15.3979 10.6173 15.007 11.0081C14.6161 11.399 13.9824 11.399 13.5915 11.0081Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.c9398c874741ce0fd299199f59dee710.svg";
export { ForwardRef as ReactComponent };